export function DashboardResizeHandle({ isResizing, onMouseDown }) {
  return (
    <div
      data-testid="dashboard-resize-handle"
      className={`w-1 flex-shrink-0 cursor-col-resize bg-border transition-colors hover:bg-white/30 ${
        isResizing ? 'bg-white/50' : ''
      }`}
      onMouseDown={onMouseDown}
      style={{ touchAction: 'none' }}
    />
  );
}
